document.addEventListener('DOMContentLoaded', function() {
  const searchIcon = document.querySelector('.site-header__search-icon');
  const searchForm = document.querySelector('#mobile_search form');

  if (searchIcon && searchForm) {
    searchIcon.addEventListener('click', function(e) {
      e.preventDefault();
      if (searchForm.style.display === 'none' || !searchForm.style.display) {
        searchForm.style.display = 'block';
      } else {
        searchForm.style.display = 'none';
      }
    });
  }
});

